import ApiTrafficStatusBadge from "views/components/Badges/StatusBadges"

export function ApiTrafficLogSummary ({ log }) {
  const fields = [
    ['Tanggal', log.date],
    ['Dari', log.from],
    ['Ke Endpoint', <code key="endpoint">{log.endpoint}</code>],
    ['Status', <ApiTrafficStatusBadge key="status" status={log.status} />],
    ['Created', log.createdAt],
    ['Modified', log.updatedAt]
  ]

  return (
    <div className="card mb-3">
      <div className="card-header">
        <h5 className="card-title mb-0">
          <i className="fa-solid fa-circle-info me-1" /> Summary
        </h5>
      </div>
      <div className="card-body">
        <div className="row g-3">
          {fields.map(([label, value]) => (
            <div key={label} className="col-6 col-md-3">
              <div className="text-muted small">{label}</div>
              <div className="fw-semibold">{value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
